import React, { useState, useEffect } from 'react';
import { PrepAdminLayout } from '../../../components/prep/PrepAdminLayout';
import { Card, CardContent, CardHeader, CardTitle } from '../../../components/ui/card';
import { Button } from '../../../components/ui/button';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Textarea } from '../../../components/ui/textarea';
import { toast } from 'sonner';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const Field = ({ label, value, onChange, multiline, rows = 2 }) => (
  <div>
    <Label>{label}</Label>
    {multiline
      ? <Textarea rows={rows} value={value || ''} onChange={e => onChange(e.target.value)} className="mt-1" />
      : <Input value={value || ''} onChange={e => onChange(e.target.value)} className="mt-1" />}
  </div>
);

export const PrepAdminHomeContent = () => {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    axios.get(`${API}/prep/content/prep-home`).then(r => setContent(r.data)).catch(console.error);
  }, []);

  const set = (key, val) => setContent(prev => ({ ...prev, [key]: val }));

  const save = async () => {
    setSaving(true);
    try {
      await axios.put(`${API}/prep/content/prep-home`, { data: content }, { withCredentials: true });
      toast.success('Home page updated');
    } catch { toast.error('Failed to save'); }
    finally { setSaving(false); }
  };

  if (!content) return <PrepAdminLayout title="Edit Prep Home"><div className="py-8 text-center text-gray-400">Loading...</div></PrepAdminLayout>;

  return (
    <PrepAdminLayout title="Edit Certification Prep Home">
      <div className="max-w-2xl space-y-6">
        <Card className="border-2">
          <CardHeader><CardTitle>Hero Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Main Headline" value={content.hero_headline} onChange={v => set('hero_headline', v)} />
            <Field label="Subheadline" value={content.hero_subheadline} onChange={v => set('hero_subheadline', v)} multiline rows={3} />
            <Field label="Primary Button Text" value={content.hero_btn_primary} onChange={v => set('hero_btn_primary', v)} />
            <Field label="Secondary Button Text" value={content.hero_btn_secondary} onChange={v => set('hero_btn_secondary', v)} />
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>"Why Students Choose Us" Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Section Title" value={content.why_title} onChange={v => set('why_title', v)} />
            <Field label="Section Subtitle" value={content.why_subtitle} onChange={v => set('why_subtitle', v)} multiline />
            {[1,2,3,4].map(n => (
              <div key={n} className="border rounded-lg p-4 space-y-2 bg-gray-50">
                <p className="text-sm font-semibold text-gray-600">Feature Card {n}</p>
                <Field label="Title" value={content[`feature_${n}_title`]} onChange={v => set(`feature_${n}_title`, v)} />
                <Field label="Description" value={content[`feature_${n}_desc`]} onChange={v => set(`feature_${n}_desc`, v)} multiline rows={2} />
              </div>
            ))}
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Programs Section</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Section Title" value={content.programs_title} onChange={v => set('programs_title', v)} />
            <Field label="Section Subtitle" value={content.programs_subtitle} onChange={v => set('programs_subtitle', v)} />
          </CardContent>
        </Card>

        <Card className="border-2">
          <CardHeader><CardTitle>Bottom CTA</CardTitle></CardHeader>
          <CardContent className="space-y-4">
            <Field label="Headline" value={content.cta_headline} onChange={v => set('cta_headline', v)} />
            <Field label="Description" value={content.cta_description} onChange={v => set('cta_description', v)} multiline />
            <Field label="Button Text" value={content.cta_button} onChange={v => set('cta_button', v)} />
          </CardContent>
        </Card>

        <Button onClick={save} disabled={saving} className="bg-blue-600 hover:bg-blue-700 text-white w-full">
          {saving ? 'Saving...' : 'Save All Changes'}
        </Button>
      </div>
    </PrepAdminLayout>
  );
};
